import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Text from 'components/Text';
import { BlueButton } from 'components/Button';
import Break from 'components/Break';
import { Link } from '@reach/router';
import { ROLES_DISPLAY_NAMES } from 'utils/appConstants';

const AccountPage = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  position: relative;
`;

const AccountInfoPanel = styled.div`
  width: 575px;
  background-color: #ffffff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-top: 80px;
  padding: 35px 45px 25px;
`;

const AccountInfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 16px 0px;
`;

const InfoType = styled(Text)`
  font-size: 12px;
  color: #4a4a4a;
  width: 30%;
  margin: auto 0px;
`;

const Account = () => {
  const authenticatedUser = useSelector(state => state.auth.authenticatedUser);
  const [role, setRole] = useState('');
  const { firstName, lastName, email, roleName } = authenticatedUser;

  useEffect(() => {
    setRole(ROLES_DISPLAY_NAMES[roleName]);
  }, [roleName]);

  return (
    <AccountPage>
      <AccountInfoPanel>
        <Text margin="20px 0px 28px">Account Information</Text>
        <AccountInfoRow>
          <InfoType>Name</InfoType>
          <Text fontSize="16px" color="#4A4A4A">
            {`${firstName} ${lastName}`}
          </Text>
        </AccountInfoRow>
        <AccountInfoRow>
          <InfoType>Email Address</InfoType>
          <Text fontSize="16px" color="#4A4A4A">
            {email}
          </Text>
        </AccountInfoRow>
        <AccountInfoRow>
          <InfoType>Role</InfoType>
          <Text fontSize="16px" color="#4A4A4A">
            {role}
          </Text>
        </AccountInfoRow>
        <AccountInfoRow>
          <InfoType>Password</InfoType>
          <Text fontSize="16px" color="#4A4A4A">
            &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
          </Text>
        </AccountInfoRow>
        <Break margin="24px 0px" />
        <Link to="/account/edit">
          <BlueButton>Edit Account</BlueButton>
        </Link>
      </AccountInfoPanel>
    </AccountPage>
  );
};

export default Account;
